/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locationId, location) => ({
    type: actions.EDIT_LOCATION,
    payload: {
        id: locationId,
        location,
    },
});